<template>
  <navbar-component />
  <main v-if="!loading" class="container-xxl demand-letter-container pt-4 pb-4">
    <matter-name :matter-name="matterName" />
    <demand-letter-process-section
      ref="processSection"
      :session-data="sessionData"
      :status="sessionData.status"
      :session-id="sessionId"
      :handle-fetch-session-info="fetchSessionInfo"
    >
    </demand-letter-process-section>
    <general-info
      v-if="isGeneralInfoFetched"
      :inputs-data="generalInfoInputs"
      :session-id="sessionId"
      :session-status="sessionData.status"
      :matter-name="matterName"
      :selected-template-name="sessionData.generalInfo.templateName"
      :additional-info="additionalInfo"
    />
  </main>
  <loading-spinner v-else />
</template>

<script lang="ts">
import NavbarComponent from '@/components/Navbar.vue';
import DemandLetterProcessSection from '@/components/DemandLetterProcessSection.vue';
import GeneralInfo from '@/components/GeneralInfo.vue';
import { getSessionById } from '@/common/api';
import MatterName from '@/components/MatterName.vue';
import generalInfoMixin from '@/mixins/generalInfoMixin';
import { defineComponent } from 'vue';
import { Session } from '@/types/Session';
import { handleError } from '@/common/errors';
import LoadingSpinner from '@/components/LoadingSpinner.vue';

export default defineComponent({
  name: 'DemandLetterView',

  components: {
    LoadingSpinner,
    MatterName,
    NavbarComponent,
    GeneralInfo,
    DemandLetterProcessSection,
  },

  mixins: [generalInfoMixin],

  props: {
    sessionId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      loading: true,
      sessionData: {
        generalInfo: {},
        demandLetter: '',
      } as Session,
    };
  },

  async mounted() {
    await this.fetchSessionInfo();
  },

  methods: {
    async fetchSessionInfo(showLoading = true) {
      if (showLoading) {
        this.loading = true;
      }

      try {
        const response = await getSessionById(this.sessionId);

        if (response.status === 200) {
          this.sessionData = response.data;

          this.loading = false;

          if (this.sessionData.generalInfo) {
            this.setGeneralInfo(this.sessionData.generalInfo);
          }
        }
      } catch (error: unknown) {
        handleError(error, "Failed to get session's data");
      }
    },
  },
});
</script>

<style scoped>
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

p {
  margin: 0;
  font-size: 16px;
  color: #333;
}
</style>
